import type { FormState, RegisterReference } from '@/shared/types/users.types';
import type { ColorHelpers } from '@/utils/colorHelpers';
import { LocalizationInputGroup, type LocalizationValue } from '@/backoffice/components/forms/LocalizationInputGroup';
import { resolveSecteur } from '@/domains/api/geography.api';

interface Props {
    form: FormState;
    set: <K extends keyof FormState>(k: K, v: FormState[K]) => void;
    reference: RegisterReference;
    c: ColorHelpers;
}

export function StepIdentity({ form, set, reference }: Props) {
    const localization: LocalizationValue = {
        countryId: form.countryId,
        regionId: form.regionId,
        prefectureId: form.prefectureId,
        communeId: form.communeId,
        districtId: form.districtId,
        secteurId: form.secteurId,
    };

    const handleLocalization = (value: LocalizationValue) => {
        set('countryId', value.countryId);
        set('regionId', value.regionId);
        set('prefectureId', value.prefectureId);
        set('communeId', value.communeId);
        set('districtId', value.districtId);
        set('secteurId', value.secteurId);
        if (value.secteurId) {
            resolveSecteur(value.secteurId)
                .then((hierarchy) => {
                    const districtName = hierarchy.district?.name;
                    const zone = districtName
                        ? reference.zones.find((zoneItem) => zoneItem.name === districtName)
                        : undefined;

                    set('zoneId', zone ? String(zone.id) : '');
                })
                .catch(() => set('zoneId', ''));
        } else {
            set('zoneId', '');
        }
    };

    return (
        <div className="space-y-5">
            <h2 className="text-xl font-semibold text-gray-900">Localisation</h2>
            <p className="text-sm text-gray-500">
                Indiquez votre position.
            </p>

            <LocalizationInputGroup value={localization} onChange={handleLocalization} showCoordinates />
        </div>
    );
}
